import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const ConfirmationDialog = ({ open, onClose, onConfirm, message, title,lngsltd }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{lngsltd["Confirmation"]}</DialogTitle>
            <DialogContent>
                <DialogContentText>{lngsltd["Are you sure you want to exit the quiz?"]}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {lngsltd["Cancel"]}
                </Button>
                <Button onClick={onConfirm} color="primary" autoFocus>
                    {lngsltd["Confirm"]}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
